import Vue from 'vue'

export const tableMixis = {
  data () {
    return {
      pageSizes: [10, 15, 30, 60, 100],
      total: 0,
    }
  },

  methods: {
    //设置表头样式
    setHeadeStyle (data) {
      if (data.rowIndex == 0) {
        return { background: '#F6F6F6', 'font-weight': '500', color: '#333940' }
      }

    },

    handleSizeChange (data) {
      this.filter.pageSize = data;
      this.handleSearch(this.filter)
    },

    handleCurrentChange (data) {
      this.filter.pageNumber = data;
      this.handleSearch(this.filter)
    },

    //条件搜索
    conditionSearch () {
      this.filter.pageNumber = 1;
      this.handleSearch(this.filter)
    },
  }
}